import { Suspense, useState } from "react";

import { Card, CardSubtitleHeader, CardTextContent } from "@/components/Card";
import { TextLoading } from "@/components/TextLoading";

import { EditingEventSummaryCard } from "./EditingEventSummaryCard";
import { StaticEventSummaryCard } from "./StaticEventSummaryCard";

export function EventSummaryCard() {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <Suspense
      fallback={
        <Card>
          <CardSubtitleHeader>
            <TextLoading />
          </CardSubtitleHeader>
          <CardTextContent className="flex flex-col gap-2">
            <p className="min-w-0">
              <TextLoading />
            </p>
            <p className="min-w-0">
              <TextLoading />
            </p>
          </CardTextContent>
        </Card>
      }
    >
      {isEditing ? (
        <EditingEventSummaryCard onStopEditing={() => setIsEditing(false)} />
      ) : (
        <StaticEventSummaryCard onEdit={() => setIsEditing(true)} />
      )}
    </Suspense>
  );
}
